export default __webpack_public_path__ + "static/media/home-photography-bg-img-03.b2d7dda8.jpg";